"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StunEffectHandler = exports.StunEffectArgs = void 0;
const __1 = require("../../..");
const Random_1 = require("../../../utils/Random");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const RecentlyStunned_1 = require("./RecentlyStunned");
class StunEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Stun;
        this.__typeName = "Stun";
        this.name = "Stun";
        this.harmful = true;
    }
}
exports.StunEffectArgs = StunEffectArgs;
let StunEffectHandler = class StunEffectHandler {
    apply(sequence, container, state) {
        if (container.hasEffectOfType(state.targetId, EffectType_1.EffectType.StunImmunity)) {
            container.cancelEffect(sequence, state.id);
            return;
        }
        const recentlyStunned = container.getEffectsOfType(state.targetId, EffectType_1.EffectType.RecentlyStunned).length;
        // 25% chance to cancel the effect per stack
        if ((0, Random_1.random)(1, 4) <= recentlyStunned) {
            container.cancelEffect(sequence, state.id);
            return;
        }
        const dizzyVfx = new __1.AuraVfxStepArgs(new __1.ActorVfxLocationSelector(state.targetId, "head"), "Dizzy");
        state.meta.vfxStepArgsId = dizzyVfx.id;
        sequence.push(dizzyVfx);
    }
    remove(sequence, container, state) {
        sequence.push(new __1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
        if (container.isDeceased(state.targetId)) {
            return;
        }
        container.applyBuff({
            sequence,
            creatorId: state.targetId,
            targetId: state.targetId,
            duration: Duration_1.Duration.Turns(3),
            supernatural: true,
            effect: new RecentlyStunned_1.RecentlyStunnedEffectArgs()
        });
    }
};
StunEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Stun)
], StunEffectHandler);
exports.StunEffectHandler = StunEffectHandler;
